import React from "react";

import CheckoutCard from "app/checkout/CheckoutCard";
import styles from "./OrderSummaryBlock.module.scss";
import CartLineItem from "app/checkout/subscriptionSummary/CartLineItem";

/**
 * Deliberately the same `CartLineItem` the basket uses, so the customer sees
 * the item they were looking at a moment ago rather than a second rendering of
 * it. The confirmation-only bits — the delivery frequency line and the greyed
 * variant — come through as props.
 */
const OrderSummaryBlock = ({ className, discount, lineItems, total }) => {
  if (!lineItems.length) {
    return null;
  }

  return (
    <CheckoutCard className={className}>
      <div>
        <p className="gkit-p-20 gkit-mobile-17 gkit-mt-0 gkit-mb-4">
          Your order
        </p>

        <div className={styles.lineItems}>
          {lineItems.map((lineItem) => (
            <CartLineItem
              key={String(lineItem.id)}
              lineItem={lineItem}
              subtitle={lineItem.subtitle}
              variantClassName="gkit-light"
            />
          ))}
        </div>

        <div className={styles.totals}>
          {discount && (
            <div className={styles.row}>
              <p className="gkit-p-15 gkit-mobile-13 gkit-m-0">Discount</p>
              <p className="gkit-p-15 gkit-mobile-13 gkit-m-0">
                -{discount.formatted}
              </p>
            </div>
          )}

          {total && (
            <div className={styles.row}>
              <p className="gkit-p-17 gkit-mobile-15 gkit-bold gkit-m-0">
                Total
              </p>
              <p className="gkit-p-17 gkit-mobile-15 gkit-bold gkit-m-0">
                {total.formatted}
              </p>
            </div>
          )}
        </div>
      </div>
    </CheckoutCard>
  );
};

export default OrderSummaryBlock;
